import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { animated, config, useSpring } from '@react-spring/web';
import Typography from '../next-ui/Typography';

function ReactionOptionButton({ children, label, onClick }) {
  const [showLabel, setShowLabel] = useState(false);

  const animation = useSpring({
    scale: showLabel ? 1.2 : 1,
    translateY: showLabel ? -8 : 0,
    config: config.wobbly, // Adjust the spring animation config as needed
  });

  const handleMouseEnter = () => {
    setShowLabel(true);
  };

  const handleMouseLeave = () => {
    setShowLabel(false);
  };

  return (
    <div className="relative">
      {showLabel && (
        <div className="absolute left-1/2 top-[-40px] translate-x-[-50%] transform">
          <div className="rounded-md bg-text-secondary px-3 py-0.5">
            <Typography variant="body2" color="white">
              {label}
            </Typography>
          </div>
        </div>
      )}
      <animated.button
        style={animation}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="px-0.5 py-1 focus:outline-none">
        {children}
      </animated.button>
    </div>
  );
}

ReactionOptionButton.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ReactionOptionButton;
